import React from "react";

import RequireAuth from "./requireAuth";
import ProtectedRoute from "./protectedRoute";

import PrivateLayout from "../layouts/privateLayout";

import Dashboard from "../features/dashboard";
import ManageUsers from "../features/users";
import CreateUser from "../features/users/create";
import Profile from "../features/users/profile";
import ManageAddress from "../features/address";
import AddAddress from "../features/address/create";
import ChangePassword from "../features/account/changePassword";
import Products from "../features/product";
import AddProduct from "../features/product/create";
import Discounts from "../features/discount";
import AddDiscount from "../features/discount/create";
import Orders from "../features/orders";
import ViewOrder from "../features/orders/view";
import Transactions from "../features/transaction";
import OrderCancelRequests from "../features/orderCancelRequest";

const PrivateRoutes = [
  {
    element: (
      <RequireAuth>
        <PrivateLayout />
      </RequireAuth>
    ),
    path: "/",
    children: [
      {
        path: "/dashboard",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: "/users",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <ManageUsers />
          </ProtectedRoute>
        ),
      },
      {
        path: "/users/create",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <CreateUser />
          </ProtectedRoute>
        ),
      },
      {
        path: "/users/edit/:userId",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <CreateUser />
          </ProtectedRoute>
        ),
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute
            allowedRoles={["super_admin", "administrator", "customer"]}
          >
            <Profile />
          </ProtectedRoute>
        ),
      },
      {
        path: "/change-password",
        element: (
          <ProtectedRoute
            allowedRoles={["super_admin", "administrator", "customer"]}
          >
            <ChangePassword />
          </ProtectedRoute>
        ),
      },
      {
        path: "/address",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <ManageAddress />
          </ProtectedRoute>
        ),
      },
      {
        path: "/address/create/:userId",
        element: (
          <ProtectedRoute
            allowedRoles={["super_admin", "administrator", "customer"]}
          >
            <AddAddress />
          </ProtectedRoute>
        ),
      },
      {
        path: "/address/edit/:userId/:addressId",
        element: (
          <ProtectedRoute
            allowedRoles={["super_admin", "administrator", "customer"]}
          >
            <AddAddress />
          </ProtectedRoute>
        ),
      },
      {
        path: "/products",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <Products />
          </ProtectedRoute>
        ),
      },
      {
        path: "/products/create",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <AddProduct />
          </ProtectedRoute>
        ),
      },
      {
        path: "/products/edit/:productId",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <AddProduct />
          </ProtectedRoute>
        ),
      },
      {
        path: "/discounts",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <Discounts />
          </ProtectedRoute>
        ),
      },
      {
        path: "/discounts/create",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <AddDiscount />
          </ProtectedRoute>
        ),
      },
      {
        path: "/discounts/edit/:discountId",
        element: (
          <ProtectedRoute allowedRoles={["super_admin", "administrator"]}>
            <AddDiscount />
          </ProtectedRoute>
        ),
      },
      {
        path: "/orders",
        element: (
          <ProtectedRoute
            allowedRoles={["super_admin", "administrator", "customer"]}
          >
            <Orders />
          </ProtectedRoute>
        ),
      },
      {
        path: "/orders/view/:orderId",
        element: (
          <ProtectedRoute
            allowedRoles={["super_admin", "administrator", "customer"]}
          >
            <ViewOrder />
          </ProtectedRoute>
        ),
      },
      {
        path: "/transactions",
        element: (
          <ProtectedRoute
            allowedRoles={["super_admin", "administrator", "customer"]}
          >
            <Transactions />
          </ProtectedRoute>
        ),
      },
      {
        path: "/order-cancel-request",
        element: (
          <ProtectedRoute
            allowedRoles={["super_admin", "administrator", "customer"]}
          >
            <OrderCancelRequests />
          </ProtectedRoute>
        ),
      },
    ],
  },
];

export default PrivateRoutes;
